







        
  import { getDefaultAloIcon } from '@/models/alo/AloIcon'
import Vue from 'vue'  
  import Component from 'vue-class-component'  

  @Component({
    name: 'IcoBadgeBtn', 
    props:{            
      iconId:{
        type:Number,
        default:0
      },
      icoBadge:{
        type:String,
        default:'mdi-exclamation'
      },
      icoBadgeSelected:{
        type:String,
        default:'mdi-check'
      },
      showValueOnBadge:{
        type:Boolean,
        default:false
      },
      selected:{
        type:Boolean,
        default:false
      },
      qty:{
        type:Number,
        default:0
      },      
      showQtySelected:{
        type:Boolean,
        default:true
      },
      qtySelected:{
        type:Number,
        default:0
      },
      label:{
         type:String,
         default:''
      },
      small:{
         type:Boolean,
         default:false
      }
    }
  })
  export default class IcoBadgeBtn extends Vue {  
    iconId!:number
    icoBadge!:string   
    icoBadgeSelected!:string 
    selected!:string
    qty!:number
    label!:string
    showValueOnBadge!:boolean
    small!:boolean
    showQtySelected!:boolean
    qtySelected!:number


    get iconsDic(){
      return this.$store.myGetters.iconsDic
    }

    get icon(){
      return this.iconsDic[this.iconId]?this.iconsDic[this.iconId]:getDefaultAloIcon()
    }

    get iconUrl(){
      return this.selected?this.icon.selectedIcon:this.icon.icon
    }

    get badgeIcon(){
      return this.selected?this.icoBadgeSelected:this.icoBadge
    }

    get badgeContent()  {
      return this.showValueOnBadge?this.qty:''
    }

  }
